import React from "react";
import { useLocation } from "react-router-dom";
import { routeHome, routeLogin } from "@navigation/typedRoutes";
import NotFoundView from "@view/NotFound.view";
import { buildNotFoundViewProps } from "@ps-bridge/notFound.program";
import type { NotFoundKernel } from "@ps-bridge/contracts/notFound";

const NotFoundPage: React.FC = () => {
  const location = useLocation();
  const path = location.pathname || "/";
  const kernel: NotFoundKernel = {};
  const viewProps = buildNotFoundViewProps({
    kernel,
    path,
    homeRoute: routeHome,
    loginRoute: routeLogin,
  });

  return <NotFoundView {...viewProps} />;
};

export default NotFoundPage;
